import React from "react";
import Navbar from "../Components/Navbar";


function Programs(){
    return (
        <div>
            

            <div className="">
        Hello from Programs
            </div>
        </div>
    )
}
export default Programs;